import { useAppSelector } from 'hooks/useAppSelector';
import { SearchCodeType, SearchType } from 'state/workspaces/secondary-market/batch/model';
import { getSearchByCode } from 'state/workspaces/secondary-market/batch/selectors';

function asSearchType({ code, subType }: SearchCodeType): SearchType {
  return { source: code as any, subtype: subType } as any;
}

export function useSearchCodeTypesItems() {
  const searchByCode = useAppSelector(getSearchByCode);
  const count = (searchByCode?.primary?.length ?? 0) + (searchByCode?.extended?.length ?? 0);

  return {
    primaryItems: searchByCode?.primary.map(asSearchType) ?? [],
    extendedItems: searchByCode?.extended.map(asSearchType) ?? [],
    isEmpty: count === 0,
    isReadonly: count <= 1,
  };
}
